var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('h4',[_vm._v(_vm._s(_vm.date))]),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }